<router-outlet (activate)="onActivate()"></router-outlet>
<ngx-ui-loader fgsColor="var(--sp-color-main)"></ngx-ui-loader>
